<template>
  <div class="ptSlider">
    <div v-for="(item,index) in 10" @click="switchStep(index)"
         :class="currStep >= (index+1)*10 ? 'activeStep':'defaultStep'"  :style="styleObj"></div>
    <div class="stepNumber" :class="blackhillsYellow ? 'blackhillsYellow' : ''">{{currStep}}%</div>
  </div>
</template>

<script>
  export default {
    name: 'ptSlider',
    props:{
      oldStep:{
        type:Number,
        default:50
      },
      styleObj:{
        type:Object,
      },
      editMode:{
        type:Boolean,
        default:false
      },
      blackhillsYellow:{
        type: Boolean,
        default: false
      },
    },
    watch:{
      oldStep(newValue){
        if(newValue){
          this.currStep = newValue;
        }
      }
    },
    data(){
      return{
        currStep:50,
      }
    },
    mounted () {
      this.updateStep();
    },
    methods:{
      updateStep(){
        this.currStep = this.oldStep;
      },
      switchStep(index){
        if(this.editMode){
          this.currStep = (index+1) * 10;
          this.$emit('changeStep',this.currStep);
        }
      },
    }
  }
</script>

<style scoped lang="less">
  @import "../../core/diy";
  .ptSlider{
    display: flex;
    flex-direction: row;
    align-items: center;
    .activeStep{
      background: #FABE00;
      transition: background-color .15s ease-in-out;
      border-radius: 1px;
      width: 14px;
      height: 14px;
      margin-right: 3px;
      cursor: pointer;
    }
    .defaultStep{
      background: #EBEBEB;
      transition: background-color .15s ease-in-out;
      border-radius: 1px;
      width: 14px;
      height: 14px;
      margin-right: 3px;
      cursor: pointer;
    }
    .stepNumber{
      font-size: 12px;
      color: #333333;
      width: 34px;
      text-align: right;
    }
    .blackhillsYellow{
      color: @blackhills-yellow;
    }
  }
</style>